import React, {useState} from "react";
import "./dual-set-data-table.styles.scss";

import CustomButton from "../../commons/custom-button/custom-button.component";
import {useDispatch, useSelector} from "react-redux";
import EmptyTableComponent from "../empty-component/empty-table-compontent";
import StatusBox from "../../commons/status/retangle-for-status";
import moment from "moment";
import {getQueuedData} from "../../../redux/clientdata/client.action";
import {CustomDateFormat} from "../../../redux/clientdata/client.reducer";
import {createToken} from "../../../js/api/_azure-queue.data";
import {ClientServices} from "../../../redux/clientdata/client.services";

function DualSetDataTable({
                              title,
                              filterOne,
                              filterTwo,
                              tableItemsOne,
                              tableItemsTwo,
                              categoriesOne,
                              categoriesTwo,
                              tableOneColumnWidth = "180px",
                              tableTwoColumnWidth = "210px",
                          }) {
    const [tableColumnWidth, setTableColumnWidth] = useState(tableOneColumnWidth);
    const [activeDisplay, setAtiveDisplay] = useState(filterOne);
    const [tableCategories, setTableCategories] = useState(categoriesOne);
    const [tableItems, setTableItems] = useState(tableItemsOne);

    const userQueueData = useSelector(({client}) => client.queuedData);
    const userCompletedData = useSelector(({client}) => client.completed);
    const brmsUserIdData = useSelector(({client}) => client.brmsUserId);

    const dispatch = useDispatch();
    const userEmailData = useSelector(({user}) => user.loggedin_user);  //RK--changed from verified_email to loggedin_user
    const improfileuser = useSelector(({cart}) => cart.impersonateMember.userprofile);
    const [profileuser, setProfileuser] = useState(improfileuser ? improfileuser.Email : userEmailData);
    // React.useEffect(() => {
    //     //dispatch(getCompletedData(userEmailData));
    //     //dispatch(getQueuedData(profileuser));
    // }, []);

    const toggleDisplayOne = () => {
        setTableColumnWidth(tableOneColumnWidth);
        setAtiveDisplay(filterOne);
        setTableCategories(categoriesOne);
        setTableItems(tableItemsOne);
    };

    const toggleDisplayTwo = () => {
        setTableColumnWidth(tableTwoColumnWidth);
        setAtiveDisplay(filterTwo);
        setTableCategories(categoriesTwo);
        setTableItems(tableItemsTwo);
    };

    /*if (userQueueData.length === 0 || userCompletedData.length === 0) {
        return (<EmptyTableComponent message={"You do not have remote modeling job status"}/>);
    }*/

    const onClickRefreshData = () => {
        // dispatch(getCompletedData(userEmailData));
        //dispatch(getQueuedData(userEmailData));
    };

    const getColor = (statusCode) => {
        let checkStatus = statusCode.toUpperCase();

        switch (checkStatus) {
            case "QUEUED":
                return "#9f9f9f"
            case "COMPLETED":
                return "#8CC152"
            case "FAILED":
                return "#FF0000"
            case "RUNNING":
                return "#CCE5FF"
            case "CANCELLED":
                return "#EF6008"
            default:

        }
    }

    const onDownloadResult = async (resultHttpURL) => {
        let arrayFromURL = resultHttpURL.split("/");
        let modifiedArray = arrayFromURL.slice(1).slice(-2)

        const token = await createToken();
        ClientServices.getBRMSDownload(modifiedArray[0], modifiedArray[1], token).then((e) => {
            const link = document.createElement('a');
            link.href = e;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    };

    return (
        <div className="dual-set-data-table">
            {/*<div className="trinity-container">
                <h2 className="d-lg-none">{title}</h2>
                <div filterOne className="section-filters mt-3 mb-3">
          <span
              className={`filter clickable
                            ${activeDisplay === filterOne ? "bold" : ""}
                        `}
              onClick={toggleDisplayOne}
          >
            {filterOne}
          </span>
                    <span className="seperator ml-2 mr-2">|</span>
                    <span
                        className={`filter clickable
                            ${activeDisplay === filterTwo ? "bold" : ""}
                        `}
                        onClick={toggleDisplayTwo}
                    >
            {filterTwo}
          </span>
                </divfilterOne>
                <CustomButton onClick={() => onClickRefreshData()} style={{marginLeft: 10}}>Refresh Data</CustomButton>
            </div>*/}

            <div className="trinity-container">
                <iframe src={"https://brms.breeze-software.com/JobStatus.aspx?id=" + brmsUserIdData}
                        style={{width: "100%", height: "700px"}}
                        frameBorder="0"/>
                {/*<div className="overflow-width-setter">
                    <div className="table-categories mb-3">
                        <div className="trinity-container d-flex fluid">
                            {tableCategories.map((category) => (
                                <h5
                                    key={category}
                                    style={{width: tableColumnWidth}}
                                    className="category column m-0"
                                >
                                    <span className="mr-2">{category}</span>
                                </h5>
                            ))}
                        </div>
                    </div>

                    {activeDisplay === filterOne && userCompletedData && (
                        <div className="trinity-container">
                            <div className="table-items">
                                {userCompletedData.map((item, i) => {
                                    // { customer_id, data, software, edition, version, released, activated, maintenance }
                                    return (
                                        <div key={Math.random() * 100 + i} className="table-item">
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.RunId}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.ProjectName}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {getRunTime(item.StartTime)}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.ArrivalTime}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.StartTime}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.EndTime}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {"$" + item.InvoiceAmount.toFixed(2)}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                <StatusBox text={item.Status}
                                                           color={getColor(item.Status)}
                                                           borderColor={getColor(item.Status)}/>
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.ResultsHttp && item.Status.toUpperCase() === "COMPLETED" && <CustomButton
                                                    onClick={() => onDownloadResult(item.ResultsHttp)}>Download</CustomButton>}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {activeDisplay === filterTwo && userQueueData && (
                        <div className="trinity-container">
                            <div className="table-items">
                                {userQueueData.map((item, j) => {
                                    // { customer_id, data, software, edition, version, released, activated, maintenance }
                                    console.log(item.Status);
                                    return (
                                        <div key={Math.random() * 100 + j} className="table-item">
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.RunId}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.ProjectName}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {getRunTime(item.StartTime)}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.ArrivalTime}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {moment(moment(item.StartTime).format("MM/DD/YY h:mm:ss")).format('MMMM Do YYYY, h:mm:ss')}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                <StatusBox text={item.Status}
                                                           color={getColor(item.Status)}
                                                           borderColor={getColor(item.Status)}/>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>*/}
            </div>
        </div>
    );
}

const getRunTime = (runtimeFee) => {
    let runTime = ((new Date((new Date().getTime()) - (new Date(Date.parse(runtimeFee))).getTime()) / 1000));
    if (runTime > 0) {
        let days = Math.floor(runTime / (3600 * 24));
        let hours = Math.floor((runTime - (days * (3600 * 24))) / 3600);
        let minutes = Math.floor((runTime - (days * (3600 * 24)) - (hours * 3600)) / 60);
        let seconds = Math.floor(runTime - (days * (3600 * 24)) - (hours * 3600) - (minutes * 60));


        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }


        return hours + ':' + minutes + ':' + seconds;
    }
    return "00:00:00";
}

const downloadContent = (url) => {
    let a = document.createElement('a');
    a.href = url;
    a.download = url.substr(url.lastIndexOf('/') + 1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export default DualSetDataTable;
